import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "type", "size", "form"]

import { PropType } from 'vue';

type ButtonSize = 'small' | 'medium' | 'large'
type ButtonType = 'button' | 'submit' | 'reset' | 'undefined'

export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    type: {
        type: String as PropType<ButtonType>,
        default: "button",
    },
    disabled: {
        type: Boolean,
        default: false
    },
    customClass: {
        type: String,
        default: "primary", // primary | secondary | tertiary | quaternary | quinary
    },
    btnWidth: {
        type: String,
        default: ""
    },
    text: {
        type: String,
        default: null
    },
    size: {
        type: String as PropType<ButtonSize>,
        default: 'medium',
    },
    form: {
        type: String,
        default: null
    },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    type: __props.type,
    size: __props.size,
    form: __props.form,
    class: _normalizeClass(["flex items-center text-center justify-center rounded relative disabled:after:opacity-0 disabled:bg-white disabled:border-neutral-100 disabled:text-neutral-100 disabled:cursor-not-allowed font-semibold text-sm transition btn", [__props.customClass, __props.btnWidth]])
  }, [
    _createTextVNode(_toDisplayString(__props.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})